import DatabaseModel from './DatabaseModel.js';
import { unwrapDto } from './responseUtils.js';

// Catálogo de festivos y pantalla de Ajustes · Festivos (#53).
// El backend responde 403 a quien no sea ADMIN o DIRECTOR: el gate de verdad está allí,
// aquí sólo se esconde lo que no se puede usar.
var Festivo = Object.create(DatabaseModel);

Festivo.model = 'rh/festivos';
Festivo.modelFront = 'festivos';

// GET /movilidad/rh/festivos/municipios?anio=2026
// → { anio, municipios:[...], noCargados, pendientesValidar, faltanLocales, validados, ... }
Festivo.municipios = function (anio) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/municipios?anio=' + encodeURIComponent(anio),
        method: 'GET'
    }, false).then(unwrapDto);
};

// GET /movilidad/rh/festivos/avisos?fresco= → [{ tipo, anio, resumen, problemas,
//   grupos:[{ motivo, descripcion, lineas:[...] }], personasSinMunicipio, detalle:[...] }]
// Solo los avisos vigentes con algo pendiente (#1210). Sin `fresco` vale el cálculo de los
// últimos minutos: es lo que pide el indicador de la cabecera al entrar.
Festivo.avisos = function (fresco) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/avisos' + (fresco ? '?fresco=true' : ''),
        method: 'GET'
    }, false).then(unwrapDto);
};

// GET /movilidad/rh/festivos/personas-sin-municipio → [{ nombre, username, empleadoId }] (#1210)
Festivo.personasSinMunicipio = function () {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/personas-sin-municipio',
        method: 'GET'
    }, false).then(unwrapDto);
};

// GET /movilidad/rh/festivos/municipios/{ine}?anio= → { municipio, festivos:[...] }
Festivo.detalle = function (municipioIne, anio) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/municipios/'
            + encodeURIComponent(municipioIne) + '?anio=' + encodeURIComponent(anio),
        method: 'GET'
    }, false).then(unwrapDto);
};

// GET /movilidad/rh/festivos/respaldo?anio=2026
// → { anio, avisos:[...], noCargados:[...], sinRespaldo, sinComprobar, noCargadosCuenta, extracciones }
// El catálogo contrastado contra la extracción del boletín que cada festivo cita (#255). Va aparte
// de `/municipios` a propósito: es otra lectura, y la tabla no puede quedarse sin pintar porque
// esta falle. Avisa y no bloquea nada.
Festivo.respaldo = function (anio) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/respaldo?anio='
            + encodeURIComponent(anio),
        method: 'GET'
    }, false).then(unwrapDto);
};

// POST /movilidad/rh/festivos/ → el festivo creado (nace en PROPUESTO)
Festivo.crear = function (data) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/',
        method: 'POST',
        data: data
    }, false).then(unwrapDto);
};

// PUT /movilidad/rh/festivos/{id} → el festivo corregido
Festivo.actualizar = function (id, data) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(id),
        method: 'PUT',
        data: data
    }, false).then(unwrapDto);
};

// DELETE /movilidad/rh/festivos/{id}?motivo=&confirmoCompartido=
// Un nacional o un autonómico es un solo registro para muchos municipios: el backend rechaza el
// borrado si no llega `confirmoCompartido` (#1148), así que solo se manda después de que la
// pantalla haya dicho a cuántos municipios y personas llega y la persona lo haya confirmado.
Festivo.borrar = function (id, motivo, confirmoCompartido) {
    const self = this;
    const params = [];
    if (motivo) params.push('motivo=' + encodeURIComponent(motivo));
    if (confirmoCompartido) params.push('confirmoCompartido=true');
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(id)
            + (params.length ? '?' + params.join('&') : ''),
        method: 'DELETE'
    }, false).then(unwrapDto);
};

// POST /movilidad/rh/festivos/{id}/no-aplica { codComunidad, motivo, fuenteRef, fuenteUrl }
// → el festivo con su lista `noAplicaEn` (#1148). Solo nacionales; el backend rehace los
// calendarios de los municipios de esa comunidad y de ninguna otra.
Festivo.noAplicaEn = function (id, data) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(id) + '/no-aplica',
        method: 'POST',
        data: data
    }, false).then(unwrapDto);
};

// DELETE /movilidad/rh/festivos/{id}/no-aplica/{codComunidad}?motivo= → el festivo (#1148)
Festivo.vuelveAAplicar = function (id, codComunidad, motivo) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(id)
            + '/no-aplica/' + encodeURIComponent(codComunidad) + '?motivo=' + encodeURIComponent(motivo),
        method: 'DELETE'
    }, false).then(unwrapDto);
};

// POST /movilidad/rh/festivos/validar → la fila del municipio ya validada
Festivo.validar = function (anio, municipioIne, motivo) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/validar',
        method: 'POST',
        data: { anio: anio, municipioIne: municipioIne, motivo: motivo }
    }, false).then(unwrapDto);
};

// POST /movilidad/rh/festivos/completo-locales → la fila del municipio
// El motivo es obligatorio; `deshacer` lo devuelve a «faltan locales».
Festivo.completoLocales = function (anio, municipioIne, motivo, deshacer) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/completo-locales',
        method: 'POST',
        data: { anio: anio, municipioIne: municipioIne, motivo: motivo, deshacer: deshacer === true }
    }, false).then(unwrapDto);
};

// GET /movilidad/rh/festivos/publicacion/vista-previa?anio=&municipioIne=
// → { calendarios, tareas, choques, detalleChoques:[...], yaExistentes, ... }
// Lo que se ve aquí es exactamente lo que hace `publicar`: el backend calcula el mismo plan.
Festivo.vistaPrevia = function (anio, municipioIne) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/publicacion/vista-previa?anio='
            + encodeURIComponent(anio)
            + (municipioIne ? '&municipioIne=' + encodeURIComponent(municipioIne) : ''),
        method: 'GET'
    }, false).then(unwrapDto);
};

// POST /movilidad/rh/festivos/publicar → el resultado real de la publicación
Festivo.publicar = function (anio, municipioIne, motivo) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/publicar',
        method: 'POST',
        data: { anio: anio, municipioIne: municipioIne || null, motivo: motivo || null }
    }, false).then(unwrapDto);
};

// GET /movilidad/rh/festivos/calendario?username=&desde=&hasta=
// → [{ fecha, nombre, ambito, etiqueta }] — los días festivos de esa persona, con su ámbito.
// Sin `username` devuelve los del usuario logueado. No hace falta ser ADMIN: son los festivos
// que a uno le tocan.
//
// La API manda la lista en `dto` desde la #946, y vacía cuando no hay ninguno. Antes iba en
// `list`, y `unwrapDto` convierte una `list` vacía en `null`. Por eso aquí no se usa `unwrapDto`:
// se aceptan las dos formas —la API antigua puede seguir desplegada un tiempo— y la promesa
// resuelve SIEMPRE con un array, `[]` si no hay festivos.
Festivo.calendario = function (username, desde, hasta) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/calendario?desde='
            + encodeURIComponent(desde) + '&hasta=' + encodeURIComponent(hasta)
            + (username ? '&username=' + encodeURIComponent(username) : ''),
        method: 'GET'
    }, false).then(listaDeFestivos);
};

// `sendRequest` resuelve con el `dto` ya desempaquetado si viene (un array, aunque esté vacío),
// y si no, con el envoltorio entero.
function listaDeFestivos(res) {
    if (Array.isArray(res)) return res;
    if (res && Array.isArray(res.dto)) return res.dto;
    if (res && Array.isArray(res.list)) return res.list;
    return [];
}

export default Festivo;
